import PropTypes from 'prop-types';
import { Divider, Stack } from '@mui/material';
import { Ori } from '../../../../assets/theme/js/variables';
import QuickViewCubeIcon from './QuickViewCubeIcon';
import QuickViewsToggle from './toggles/QuickViewsToggle';
import ModelToggle from './toggles/ModelToggle';
import TextureToggle from './toggles/TextureToggle';
import LaserToggle from './toggles/LaserToggle';

function ViewerBottomDock({
    dock,
}) {
    return (
        <div className="viewer-bottom-dock">
            <div className="viewer-bottom-dock-shell">
                <div
                    className={`viewer-bottom-panel ${dock.showBottomDock ? 'is-expanded' : 'is-collapsed'}`}
                    aria-hidden={!dock.showBottomDock}
                >
                    <div
                        className={`quick-view-strip-shell ${dock.isQuickViewStripOpen ? 'is-open' : ''}`}
                        aria-hidden={!dock.isQuickViewStripOpen}
                    >
                        <Stack className="quick-view-strip" direction="row">
                            <button
                                className="quick-view utility"
                                type="button"
                                title={dock.resetView.title}
                                disabled={dock.resetView.disabled}
                                onClick={dock.resetView.onClick}
                            >
                                <i className="material-icons" role="presentation">restart_alt</i>
                                <span>Reset View</span>
                            </button>
                            <Divider orientation="vertical" flexItem sx={{ backgroundColor: Ori.gray }} />
                            {dock.quickViews.map((button) => (
                                <button
                                    key={button.id}
                                    className={`quick-view ${button.isActive ? 'active' : ''}`}
                                    type="button"
                                    title={button.title}
                                    disabled={button.disabled}
                                    onClick={button.onClick}
                                >
                                    <QuickViewCubeIcon className="quick-view-cube-icon" view={button.view} />
                                    <span>{button.label}</span>
                                </button>
                            ))}
                        </Stack>
                    </div>
                </div>
                <div className="scene-toggle-bar-shell">
                    <div
                        className={`scene-toggle-bar-stage ${dock.showBottomDock ? 'is-expanded' : 'is-collapsed'}`}
                        aria-hidden={!dock.showBottomDock}
                    >
                        <Stack className="scene-toggle-bar" direction="row">
                            <QuickViewsToggle toggle={dock.quickViewsToggle} />

                            <Divider orientation="vertical" flexItem sx={{ backgroundColor: Ori.gray }} />

                            <ModelToggle toggle={dock.modelToggle} />
                            <TextureToggle toggle={dock.textureToggle} />
                            <LaserToggle toggle={dock.laserToggle} />
                        </Stack>
                    </div>
                    <button
                        type="button"
                        className={`viewer-bottom-collapse ${dock.showBottomDock ? 'expanded' : 'collapsed'}`}
                        aria-expanded={dock.showBottomDock}
                        aria-label={dock.showBottomDock ? 'Hide bottom toolbar' : 'Show bottom toolbar'}
                        title={dock.showBottomDock ? 'Hide toolbar' : 'Show toolbar'}
                        onClick={dock.toggleCollapse}
                    >
                        <i className="material-icons" aria-hidden="true">
                            {dock.showBottomDock ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
                        </i>
                    </button>
                </div>
            </div>
        </div>
    );
}

ViewerBottomDock.propTypes = {
    dock: PropTypes.shape({
        isQuickViewStripOpen: PropTypes.bool.isRequired,
        laserToggle: PropTypes.shape({
            active: PropTypes.bool.isRequired,
            ariaLabel: PropTypes.string.isRequired,
            ariaPressed: PropTypes.bool.isRequired,
            disabled: PropTypes.bool.isRequired,
            onClick: PropTypes.func.isRequired,
            title: PropTypes.string.isRequired,
        }).isRequired,
        modelToggle: PropTypes.shape({
            ariaLabel: PropTypes.string.isRequired,
            disabled: PropTypes.bool.isRequired,
            onClick: PropTypes.func.isRequired,
            state: PropTypes.oneOf([
                'disabled',
                'mixed',
                'ply',
                'stl',
            ]).isRequired,
            title: PropTypes.string.isRequired,
        }).isRequired,
        quickViews: PropTypes.arrayOf(
            PropTypes.shape({
                disabled: PropTypes.bool.isRequired,
                id: PropTypes.string.isRequired,
                isActive: PropTypes.bool.isRequired,
                label: PropTypes.string.isRequired,
                onClick: PropTypes.func.isRequired,
                title: PropTypes.string.isRequired,
                view: PropTypes.oneOf([
                    'front',
                    'left',
                    'right',
                    'top',
                    'bottom',
                    'behind',
                ]).isRequired,
            }),
        ).isRequired,
        quickViewsToggle: PropTypes.shape({
            active: PropTypes.bool.isRequired,
            ariaLabel: PropTypes.string.isRequired,
            ariaPressed: PropTypes.bool.isRequired,
            disabled: PropTypes.bool.isRequired,
            onClick: PropTypes.func.isRequired,
            title: PropTypes.string.isRequired,
        }).isRequired,
        resetView: PropTypes.shape({
            disabled: PropTypes.bool.isRequired,
            onClick: PropTypes.func.isRequired,
            title: PropTypes.string.isRequired,
        }).isRequired,
        showBottomDock: PropTypes.bool.isRequired,
        textureToggle: PropTypes.shape({
            active: PropTypes.bool.isRequired,
            ariaLabel: PropTypes.string.isRequired,
            ariaPressed: PropTypes.bool.isRequired,
            disabled: PropTypes.bool.isRequired,
            onClick: PropTypes.func.isRequired,
            title: PropTypes.string.isRequired,
        }).isRequired,
        toggleCollapse: PropTypes.func.isRequired,
    }).isRequired,
};

export default ViewerBottomDock;
